import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import homepage from '@/components/HomePage'
import companyprofile from '@/components/CompanyProfile'
import ayoabout from '@/components/AYOAbout'
import afscabout from '@/components/AFSCAbout'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
      children: [
        {
          path: '/',
          redirect:'home-page',
          component: homepage
        },
        {
          path: 'home-page',
          component: homepage
        },
        {
          path: 'company-profile',
          component: companyprofile
        },
        {
          path: 'ayo-about',
          component: ayoabout
        },
        {
          path: 'afsc-about',
          component: afscabout
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js